<template>
    <div class="ml-1">
        <h5 class="title is-5">{{ sectionTitle }}</h5>
        <div v-if="haveSections">
            <div v-for="section in sections" :key="section.id">
                <survey-section :section="section" />
            </div>
        </div>
        <div v-if="haveQuestions" class="ml-2">
            <div v-for="question in questions" :key="question.id">
                <Question :question="question" />
            </div>
        </div>
    </div>
</template>

<script>
import Question from "./Question.vue";

export default {
    name: "survey-section",
    components: {
        Question,
    },
    props: {
        section: {
            type: Object,
            required: true,
        },
    },
    computed: {
        sectionTitle() {
            let title = this.section.title;
            let order = this.section.order;
            return `${order}. ${title}`;
        },
        haveSections() {
            return this.sections.length > 0;
        },
        sections() {
            return this.section.sections;
        },
        haveQuestions() {
            return this.questions.length > 0;
        },
        questions() {
            return this.section.questions;
        },
    },
};
</script>